import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  register: false,
  thirdPartyRegisterRequirement: false,
  login: false,
  forgetPassword: false,
  resetPassword: false,
  resendEmailVerification: false,
  exists: false,
  userInfo: false,
  updateUserInfo: false,
  permissionList: false,
  pluginOrderList: false,
};

const User = {
  register: (data) => {
    if (debugStatus.register) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Registrer and login successfully',
      });
    }

    return ApiService.post(`/register`, { data });
  },

  thirdPartyRegisterRequirement: ({ platform, data }) => {
    if (debugStatus.thirdPartyRegisterRequirement) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Registrer and login successfully',
      });
    }

    return ApiService.post(`/register/${platform}/requirement`, { data });
  },

  login: ({ email, password }) => {
    if (debugStatus.login) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Login successfully',
      });
    }

    return ApiService.post(`/login`, { data: { email, password } });
  },

  forgetPassword: ({ email }) => {
    if (debugStatus.forgetPassword) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'send reset password email successfully',
        data: {
          email,
        },
      });
    }

    return ApiService.post(`/api/user/forget_password`, { data: { email } });
  },

  resetPassword: ({ email, password, token }) => {
    if (debugStatus.resetPassword) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Reset password successfully',
        data: {
          email,
        },
      });
    }

    return ApiService.post(`/api/user/reset_password`, { data: { email, token, new_password: password } });
  },

  resendEmailVerification: () => {
    if (debugStatus.resendEmailVerification) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Resend email verification successfully',
        data: {},
      });
    }

    return ApiService.post(`/api/user/resend_email_verification`, { data: { new_email: '' } });
  },

  exists: ({ email, userName }) => {
    if (debugStatus.exists) {
      return fakeApiHelper(200, 'success', {
        data: {
          exists: true,
        },
        error: false,
        message: 'Request successfully',
      });
    }

    if (email) {
      return ApiService.get(`/api/user/exists?email=${encodeURIComponent(email)}`);
    }
    return ApiService.get(`/api/user/exists?user_name=${encodeURIComponent(userName)}`);
  },

  userInfo: () => {
    if (debugStatus.userInfo) {
      return fakeApiHelper(200, 'success', {
        data: {
          email: 'nh0985264711@gmail.com',
          first_name: 'Kuan-Jung',
          last_name: 'Chiu',
          avatar_path: '',
          avatar_url: '',
          // avatar_url: 'https://source.unsplash.com/user/erondu/240x160',
          uniqid: 'Hu90',
          user_name: 'nh0985264711',
        },
        error: false,
        message: 'Request successfully',
      });
    }

    return ApiService.get(`/api/user/info`);
  },

  updateUserInfo: (data) => {
    if (debugStatus.updateUserInfo) {
      return fakeApiHelper(200, 'success', {
        data: {
          email: 'nh0985264711@gmail.com',
          first_name: 'Kuan-Jung',
          last_name: 'Chiu',
          avatar_path: '',
          avatar_url: '',
          // avatar_url: 'https://source.unsplash.com/user/erondu/240x160',
          uniqid: 'Hu90',
          user_name: 'nh0985264711',
        },
        error: false,
        message: 'Update user info successfully',
      });
    }

    return ApiService.put(`/api/user/info`, { data });
  },

  permissionList: () => {
    if (debugStatus.permissionList) {
      return fakeApiHelper(200, 'success', {
        data: {
          first_bases: [
            {
              admins: [
                {
                  avatar_path: '/u/Hu90/avatar/1615444968-oHASznfRWQ',
                  avatar_url: 'https://storage.googleapis.com/dev-rebas/u/Hu90/avatar/1615444968-oHASznfRWQ',
                  email: 'nh0985264711@gmail.com',
                  first_name: 'KJ',
                  last_name: 'Chiu',
                  uniqid: 'Hu90',
                  user_name: 'kj.chiu73',
                },
              ],
              editors: [
                {
                  avatar_path: '',
                  avatar_url: '',
                  email: 'demo.or.test.0823@gmail.com',
                  first_name: 'TEST',
                  last_name: 'DEMO',
                  uniqid: 'u28f',
                  user_name: 'demoortest0823',
                },
              ],
              info: {
                due_date: '2021/12/31 00:00',
                full_name: '成功大學乙組棒球隊',
                games: [],
                icon_url: 'https://storage.googleapis.com/dev-rebas/fb/2LcZw/icon/1615195110-LVncrZ8Yah',
                name: '成功大學',
                players: [],
                status: 'ENABLED',
                uniqid: '2LcZw',
              },
              is_public: false,
              viewers: [],
            },
          ],
          platform: 'ADMIN',
        },
        error: false,
        message: 'Get user permission successfully',
      });
    }

    return ApiService.get(`/api/user/permission`);
  },

  pluginOrderList: () => {
    return ApiService.get(`/api/user/plugin_orders`);
  },
};

export default User;
